<template>
	<div class="login">
		<div class="overlay">
			<div class="area">
				<div class="row justify-content-md-center">
					<div class="col-12 col-md-8 col-lg-11 col-xl-9">
						<div class="row flex-row">
							<div class="col-12">
								<div
									class="clearfix btn-close"
									@click="close()"
								>
									<div class="fa fa-chevron-left f-l"></div>
									<div class="text f-l">Go Back</div>
								</div>
							</div>
							<div class="col-12 col-lg-5 login-sec">
								<div class="blue-content" id="blue_content">
									<div class="row justify-content-center">
										<div class="col-11 col-lg-10">
											<div v-if="page == 1">
												<div class="title">Sign In</div>
												<Form
													classBinding="row line-fields"
													:ref="
														LogInModel.forms.login
															.name
													"
													:forms="
														LogInModel.forms.login
															.forms
													"
													:formData="
														LogInModel.forms.login
															.data
													"
													@form-submit="
														userLogIn({
															ref: $refs[
																LogInModel.forms
																	.login.name
															],
															router: $router,
														})
													"
												/>
												<div
													class="link forgot"
													@click="
														$store.commit('page', 2)
													"
												>
													Forgot Password?
												</div>
												<div
													class="link forgot"
													@click="
														$store.commit('page', 5)
													"
												>
													Forgot Username?
												</div>
												<div
													class="btn btn-white"
													:disabled="loading"
													@click="
														userLogIn({
															ref: $refs[
																LogInModel.forms
																	.login.name
															],
															router: $router,
														})
													"
												>
													Sign In
													<div
														class="lds-ring"
														v-show="loading"
													>
														<div></div>
														<div></div>
														<div></div>
														<div></div>
													</div>
												</div>
												<div class="register">
													Don't have an account?
													<span
														class="link"
														@click="register()"
														>Register</span
													>
												</div>
											</div>
											<div v-if="page == 2">
												<Form
													classBinding="row form-box"
													:ref="
														LogInModel.forms
															.send_otp.name
													"
													:forms="
														LogInModel.forms
															.send_otp.forms
													"
													:formData="
														LogInModel.forms
															.send_otp.data
													"
												/>
												<div
													class="link forgot"
													@click="
														$store.commit('page', 1)
													"
												>
													Log In?
												</div>
												<div
													class="btn btn-white"
													:disabled="loading"
													@click="
														sendOtp({
															ref: $refs[
																LogInModel.forms
																	.send_otp
																	.name
															],
															router: $router,
														})
													"
												>
													Send OTP
													<div
														class="lds-ring"
														v-show="loading"
													>
														<div></div>
														<div></div>
														<div></div>
														<div></div>
													</div>
												</div>
											</div>

											<div v-if="page == 3">
												<Form
													classBinding="row form-box"
													:ref="
														LogInModel.forms
															.validate_otp.name
													"
													:forms="
														LogInModel.forms
															.validate_otp.forms
													"
													:formData="
														LogInModel.forms
															.validate_otp.data
													"
												/>
												<div
													class="link forgot"
													@click="resendOTP()"
												>
													Resend OTP
												</div>
												<div
													class="link forgot"
													@click="
														$store.commit('page', 1)
													"
												>
													Log In?
												</div>
												<div
													class="btn btn-white"
													:disabled="loading"
													@click="
														validateOTP({
															ref: $refs[
																LogInModel.forms
																	.validate_otp
																	.name
															],
															router: $router,
														})
													"
												>
													Validate OTP
													<div
														class="lds-ring"
														v-show="loading"
													>
														<div></div>
														<div></div>
														<div></div>
														<div></div>
													</div>
												</div>
											</div>

											<div v-if="page == 4">
												<Form
													classBinding="row form-box"
													:ref="
														LogInModel.forms
															.reset_password.name
													"
													:forms="
														LogInModel.forms
															.reset_password
															.forms
													"
													:formData="
														LogInModel.forms
															.reset_password.data
													"
												/>

												<div class="btns">
													<div
														class="btn btn-white"
														:disabled="loading"
														@click="
															resetPassword({
																ref: $refs[
																	LogInModel
																		.forms
																		.reset_password
																		.name
																],
																router: $router,
															})
														"
													>
														Change Password
														<div
															class="lds-ring"
															v-show="loading"
														>
															<div></div>
															<div></div>
															<div></div>
															<div></div>
														</div>
													</div>
												</div>
											</div>

											<div v-if="page == 5">
												<Form
													classBinding="row form-box"
													:ref="
														LogInModel.forms
															.send_otp.name
													"
													:forms="
														LogInModel.forms
															.send_otp.forms
													"
													:formData="
														LogInModel.forms
															.send_otp.data
													"
												/>
												<div
													class="link forgot"
													@click="
														$store.commit('page', 1)
													"
												>
													Log In?
												</div>
												<div
													class="btn btn-white"
													:disabled="loading"
													@click="
														sendUsername({
															ref: $refs[
																LogInModel.forms
																	.send_otp
																	.name
															],
															router: $router,
														})
													"
												>
													Send Username
													<div
														class="lds-ring"
														v-show="loading"
													>
														<div></div>
														<div></div>
														<div></div>
														<div></div>
													</div>
												</div>
											</div>

											<div v-if="page == 6">
												<div class="b-title">
													Username Sent
												</div>
												<div class="b-small-txt">
													Your username was sent to
													the channel provided.
												</div>
												<div
													class="link forgot"
													@click="
														$store.commit('page', 1)
													"
												>
													Log In?
												</div>
											</div>

											<div v-if="page == 7">
												<Form
													classBinding="row form-box"
													:ref="
														LogInModel.forms
															.validate_otp.name
													"
													:forms="
														LogInModel.forms
															.validate_otp.forms
													"
													:formData="
														LogInModel.forms
															.validate_otp.data
													"
												/>
												<div
													class="link forgot"
													@click="
														resendOTPTwoFactor()
													"
												>
													Resend OTP
												</div>
												<div
													class="link forgot"
													@click="
														$store.commit('page', 1)
													"
												>
													Log In?
												</div>
												<div
													class="btn btn-white"
													:disabled="loading"
													@click="
														validateOTPTwoFactor({
															ref: $refs[
																LogInModel.forms
																	.validate_otp
																	.name
															],
															router: $router,
														})
													"
												>
													Validate OTP
													<div
														class="lds-ring"
														v-show="loading"
													>
														<div></div>
														<div></div>
														<div></div>
														<div></div>
													</div>
												</div>
											</div>

											<div v-if="page == 8">
												<div class="expiry">
													<div class="title">
														<i
															class="fa fa-exclamation-triangle mr-2"
														></i>
														Password Expired
													</div>
													<div class="txt">
														Your Password Expired on
														{{
															moment(
																expiry_date,
															).fromNow(true)
														}}. Create a new
														Password.
													</div>

													<Form
														classBinding="row form-box"
														:ref="
															LogInModel.forms
																.reset_password
																.name
														"
														:forms="
															LogInModel.forms
																.reset_password
																.forms
														"
														:formData="
															LogInModel.forms
																.reset_password
																.data
														"
													/>

													<div class="btns">
														<div
															class="btn btn-white"
															:disabled="loading"
															@click="
																resetExpiredPassword(
																	{
																		ref: $refs[
																			LogInModel
																				.forms
																				.reset_password
																				.name
																		],
																		router: $router,
																	},
																)
															"
														>
															Save
															<div
																class="lds-ring"
																v-show="loading"
															>
																<div></div>
																<div></div>
																<div></div>
																<div></div>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div v-if="page == 9">
												<div class="expiry">
													<div class="title">
														Active Session
													</div>
													<div class="txt">
														Another device is
														already logged in with
														your credentials
													</div>

													<div
														class="device clearfix"
													>
														<div class="icon f-l">
															<i
																class="fa fa-laptop"
															></i>
														</div>
														<div class="text f-l">
															<div class="name">
																Chrome
																12.355.77488
															</div>
															<div class="ip">
																132.34.56.89
															</div>
														</div>
													</div>

													<div class="btns">
														<div class="register">
															<span
																class="link"
																@click="
																	logOutDevice()
																"
																>Log Out</span
															>
														</div>
														<div
															class="btn btn-white"
															:disabled="loading"
															@click="
																continueOnDevice(
																	{
																		ref: $refs[
																			LogInModel
																				.forms
																				.reset_password
																				.name
																		],
																		router: $router,
																	},
																)
															"
														>
															Continue Here
															<div
																class="lds-ring"
																v-show="loading"
															>
																<div></div>
																<div></div>
																<div></div>
																<div></div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 col-lg-7">
								<div class="white-content" id="white_content">
									<h2>Get more when you sign in</h2>
									<p>
										Purchase insurance product and get
										school fees loans.
									</p>
									<h4 class="title">
										You will also get access to:
									</h4>
									<ul class="benefits">
										<li>
											<i class="fa fa-check"></i> Fire
											Insurance.
										</li>
										<li>
											<i class="fa fa-check"></i> Motor
											Insurance.
										</li>
										<li>
											<i class="fa fa-check"></i> Marine
											Insurance.
										</li>
										<li>
											<i class="fa fa-check"></i> Travel
											Insurance.
										</li>
									</ul>

									<h5 class="partners-title">About Us</h5>
									<p class="font-sans">
										The most widely held misconception is
										that Insurance Companies do not want to
										pay claims and that they will use every
										dirty trick in the book not to pay your
										claim. This is, quite simply, NOT TRUE.
									</p>
									<p class="font-sans">
										The TRUTH is Insurance Companies want to
										pay Genuine Claims that comply with the
										Terms and Conditions of your Insurance
										Contract with them. Your protection and
										payment of your genuine claims is the
										purpose for which Insurance Companies
										are established and the value they add
										to the communities that they serve.
									</p>
									<p class="font-sans">
										Most of the issues that arise when you
										make a claim are as a result of our not
										understanding how Insurance works and
										our role and responsibility in the
										Insurance Contract.
									</p>
									<p class="font-sans">
										For this reason, Nexus strongly
										recommends that you read your Insurance
										Policy and Policy Schedule under the
										advice of an Insurance Intermediary, an
										Agent or Broker licensed by the
										Insurance Regulatory Authority (IRA), or
										your lawyer so that you can clearly
										understand the Insurance Contract you
										have entered with your Insurance
										Company.
									</p>
									<!-- <h5 class="partners-title">Our Partners:</h5> -->
									<!-- <div class="row partners">
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner2.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner3.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner4.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner5.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner2.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner3.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner4.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner5.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner2.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner3.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner4.png" alt=""></a>
                              </div>
                              <div class=" col-md-4">
                                    <a href="#" target="_blank"><img src="/img/partners/partner5.png" alt=""></a>
                              </div>
                           </div> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import login from './rsc/stores/login.store';

export default {
	beforeDestroy() {
		this.$store.unregisterModule('login');
		// this.unwatch()
	},
	created() {
		utils.registerModule('login', login, this.$store);
	},
	components: {
		Form: () => import('@/libs/clarks/components/form'),
	},
	data() {
		return {
			// unwatch: null,
			moment,
		};
	},
	computed: {
		...mapGetters([
			'LogInModel',
			'loading',
			'page',
			'expiry_date',
			'redirectPath',
		]),
	},
	watch: {
		// page(newVal,oldVal){
		//    console.log('changing')
		//    this.alignToCenter()
		// }
	},
	methods: {
		...mapActions([
			'userLogIn',
			'resetPassword',
			'sendUsername',
			'validateOTPTwoFactor',
			'continueOnDevice',
			'logOutDevice',
			'resetExpiredPassword',
			'resendOTPTwoFactor',
			'validateOTP',
			'sendOtp',
			'resendOTP',
			'updateRedirectPath',
		]),
		close() {
			Event.$emit('auth:show', { login: false });
		},
		register() {
			Event.$emit('auth:show', { login: false, register: true });
		},
	},
	mounted() {
		utils.registerModule('login', login, this.$store);
		console.log(
			'Initial redirectPath:',
			this.$store.state.login.redirectPath,
		);
		console.log('LOGINSTORE===', this.$store);

		// this.$store.dispatch('alignBoxToCenter', this)
		// this.unwatch = this.$store.subscribe((mutation, state) => {
		// if (mutation.type === 'page') {
		//    this.$store.dispatch('alignBoxToCenter', this)
		// }
		// });
	},
};
</script>

<style lang="less">
.login {
	.login-sec {
		display: flex;
		align-items: center;
	}
	.device {
		margin: 30px 0;

		.icon {
			font-size: 40px;
			margin: 0 10px 0 0;
		}

		.text {
			.name {
				margin: 5px 0 0 0;
			}
			.ip {
				font-size: 12px;
			}
		}
	}
	.expiry {
		margin: 0 0 20px 0;
		.txt {
			font-size: 13px;
			margin: 0 0 20px 0;
		}
	}
	.b-title {
		font-size: 24px;
		margin: 20px 0 10px 0;
	}
	.b-small-txt {
		font-size: 14px;
		margin: 0 0 50px 0;
	}
	.overlay {
		-webkit-backdrop-filter: blur(3px);
		backdrop-filter: blur(3px);
		background-color: #d6d2d2ce;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1200;
		overflow-y: auto;
	}

	.area {
		padding: 30px 0;
		position: absolute;
		z-index: 1500;
		left: 0;
		right: 0;

		.btn-close {
			color: #1761fa;
			cursor: pointer;

			.fa {
				width: 30px;
				height: 30px;
				border-radius: 50px;
				font-size: 16px;
				border: solid 2px #1761fa;
				text-align: center;
				padding: 5px 0;
			}
			.text {
				margin: 4px 0 0 10px;
				font-weight: 600;
				font-size: 17px;
			}
		}
		.btn-close:hover {
			.text {
				text-decoration: underline;
			}
		}
		.blue-content {
			position: relative;
			background: var(--primary);
			padding: 10px;
			z-index: 100;
			position: relative;
			border-radius: 8px;
			color: var(--white);
			position: absolute;
			// top: calc((100% - 434px) / 2);
			right: -55px;
			width: 100%;

			.register {
				text-align: center;
				margin: 0 0 15px 0;

				.link {
					color: var(--ne-yellow);
					text-decoration: underline;
				}
				.link:hover {
					font-weight: 600;
					color: var(--ne-yellow) !important;
				}
			}
			.title {
				margin: 35px 0 0 0;
				font-size: 20px;
			}
			.forgot {
				margin: 5px 0 5px 0;
				font-size: 13px;
			}
			.btn-white {
				background: var(--white);
				color: var(--ne-red);
				width: 100%;
				margin: 20px 0 10px 0;

				.lds-ring div {
					border-color: var(--ne-red) transparent transparent
						transparent;
				}
			}
		}
		.white-content {
			background: var(--white);
			padding: 40px 20px 40px 75px;
			border-radius: 8px;
			z-index: 50;
			color: var(--text-color) !important;
			text-align: left;

			.partners img {
				margin: 15px 15px;
				width: auto;
				height: auto;
				max-height: 100px;
				max-width: 120px;
			}
			.benefits {
				list-style-type: none;
				padding: 0;
				margin: 0;
				margin-bottom: 1.5em;

				li i {
					margin: 0 15px 0 0;
				}
			}
		}
		.line-fields {
			.form-err {
				font-size: 12px;
			}
			.form-content {
				margin: 5px 0 !important;
			}
			label {
				font-size: 12px;
				color: #898ea2;
				margin: 0;
			}
			input {
				background: transparent;
				padding: 6px 5px !important;
				border: 0;
				border-bottom: solid 2px #ffffff33;
				border-radius: 0;
				color: var(--white);
			}
		}
	}
}

@media (max-width: 992px) {
	.login {
		.area {
			.blue-content {
				position: static !important;
				border-radius: 8px 8px 0 0;
			}
			.white-content {
				margin-top: -20px;
				border-radius: 0 0 8px 8px;
				padding: 25px;
			}
		}
	}
}
</style>
